import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStore } from '../../stores';
import { InputPackagesPreview, OutputPreviewContainer } from '../../components';
import './DataCrafterAppScreen.less';
import '../../../custom_shared/styles/common.less';
import { Alert, Card } from 'antd';

const DataCrafterAppScreen: React.FC = () => {
    const appStore = useAppStore();

    const { sessionStore } = appStore;

    React.useEffect(() => {
        sessionStore.initialize();
        sessionStore.getChildSessions();
    }, [sessionStore]);

    React.useEffect(() => {
        return () => appStore.dispose();
    }, [appStore]);

    return (
        <div className="data-crafter-app-screen">
            {sessionStore.errors.length > 0 && (
                <Alert
                    message="Error"
                    description={sessionStore.errors.map(error => error.message).join(', ')}
                    type="error"
                    className="data-crafter-error"
                />
            )}
            <Card className="data-crafter-card" title="Input Packages">
                <InputPackagesPreview />
            </Card>
            <OutputPreviewContainer />
        </div>
    );
};

export default observer(DataCrafterAppScreen);
